module.exports = __webpack_public_path__ + "img/prop-bird-left.bd3cef9e.png";